import OSS from 'ali-oss';
import {isObject} from "@/utils";
// const client = new OSS({
//     // 从环境变量中获取访问凭证。运行本代码示例之前，请确保已设置环境变量OSS_ACCESS_KEY_ID和OSS_ACCESS_KEY_SECRET。
//     accessKeyId: 'LTAI5tEuKSvdwMkJXebP5iDn',
//     accessKeySecret: 'UHGNneOJiIncKvVp3MuSYBdbwUOBZE',
//     // yourRegion填写Bucket所在地域。以华东1（杭州）为例，Region填写为oss-cn-hangzhou。
//     region: 'oss-cn-beijing',
//     // 使用V4签名算法
//     authorizationV4: true,
//     // yourBucketName填写Bucket名称。
//     bucket: 'noteey-data',
//     // yourEndpoint填写Bucket所在地域对应的公网Endpoint。以华东1（杭州）为例，Endpoint填写为https://oss-cn-hangzhou.aliyuncs.com。
//     endpoint: 'https://oss-cn-beijing.aliyuncs.com',
// });

/**
 * json转blob
 * @param jsonData
 */
export const jsonToBlob = (jsonData)=>{
    let jsonString = jsonData;
    if (isObject(jsonData)){
        jsonString = JSON.stringify(jsonData);
    }
    const blob = new Blob([jsonString],{type:'text/plain'});
    return blob;
}

const uploadData = ()=>{

}